/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const usePickerModalStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  button: {
    justifyContent: 'space-between',
    paddingLeft: '15px',
    paddingRight: '12px',
    width: '240px',
  },
  buttonIcon: {
    transform: 'rotate(-90deg)',
    marginLeft: '10px',
  },
});
